var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.438 13.392a.508.508 0 0 1-.867.359l-3.267-3.267a.51.51 0 0 1 0-.718L11.571 6.5a.508.508 0 0 1 .867.358z",
    "data-name": "\\uF0DA"
  })));
};
export default SvgBackIcon;